import React, {Component} from 'react';
import {InputItem} from "./InputItem";
import {isNull, validatePhone, validateEmail, applyProAndInviteCode} from "./utils";
import Button from "../Button";
import styles from "./styles.module.scss"

export const inputData: {
  showName: string,
  name: string,
  value?: string,
  required: boolean,
  prompt: string,
  id: string,
}[] = [
  {showName: '姓名',
    prompt:'请输入姓名',
    name: 'name',
    required: true,
    id: 'name'
  },
  {showName: '手机',
    prompt:'请输入手机',
    name: 'phone',
    required: true,
    id: 'phone'
  },
  {showName: '微信',
    prompt:'请输入微信',
    name: 'wechat',
    required: true,
    id: 'wechat'
  },
  {showName: '邮箱',
    prompt:'请输入公司邮箱',
    name: 'email',
    required: true,
    id: 'email'
  },
  {showName: '您的身份',
    prompt:'请选择您的身份',
    name: 'userRole',
    required: true,
    id: 'userRole'
  },
  {showName: '公司',
    prompt:'请输入公司',
    name: 'orgName',
    required: true,
    id: 'orgName'
  },
  {showName: '职位',
    prompt:'请输入职位',
    name: 'position',
    required: true,
    id: 'position'
  },
  {showName: '邀请码',
    prompt:'请输入邀请码',
    name: 'inviteCode',
    required: false,
    id: 'inviteCode'
  },
  {showName: '名片',
    prompt:'请输入名片',
    name: 'cardId',
    required: false,
    id: 'cardId'
  }
];

interface FormVar {
  name: string;
  phone: string;
  wechat: string;
  email: string;
  userRole: string;
  orgName: string;
  position: string;
  inviteCode: string;
  cardId: string;
}

interface IState extends FormVar{
  submit: boolean;
  submitting: boolean;
  showVerify: string,
  applyCount:number,
}

class Apply extends Component<{onClose: () => void; defaultInviteCode?: string}, IState>{
  constructor(props){
    super(props);
    this.state = {
      name: '',
      userRole: '',
      phone: '',
      wechat: '',
      orgName: '',
      position: '',
      email: '',
      cardId: '',
      submit: false,
      submitting: false,
      showVerify: '',
      applyCount:0,
      inviteCode: props.defaultInviteCode ?? '651386',
    }
    this.onChange = this.onChange.bind(this);
    this.confirm = this.confirm.bind(this);
    this.onClose = this.onClose.bind(this);
    this.uploadCard = this.uploadCard.bind(this);
  }

  uploadCard(gridId){
    this.setState({cardId: gridId})
  }

  onClose(){
    this.props.onClose();
    // this.setState({submitted: false})
  }

  async onChange(name: keyof FormVar, value: string){
    let state: IState = this.state;
    state[name] = value;
    await this.setState({...state, showVerify:''})
  }

  async confirm(){
    const {name, userRole, phone, wechat, orgName, position, email, cardId, applyCount, inviteCode} = this.state;

    if(applyCount>0){
      await this.setState({submitting: false, submit: true})
      return;
    }

    if(isNull(name)){
      document.getElementById("name").focus();
      this.setState({showVerify: 'name'});
      return;
    }

    if(isNull(phone) || !validatePhone(phone)) {
      document.getElementById('phone').focus();
      this.setState({showVerify: 'phone'});
      return;
    }

    if(isNull(wechat)){
      document.getElementById('wechat').focus();
      this.setState({showVerify: 'wechat'});
      return;
    }

    if(isNull(email) || !validateEmail(email)){
      document.getElementById('email').focus();
      this.setState({showVerify: 'email'});
      return;
    }

    if (isNull(userRole)) {
      document.getElementById('select_userRole').focus();
      this.setState({showVerify: 'userRole'});
      return;
    }


    if (isNull(orgName)) {
      document.getElementById('orgName').focus();
      this.setState({showVerify: 'orgName'});
      return;
    }

    if (isNull(position)) {
      document.getElementById('position').focus();
      this.setState({showVerify: 'position'});
      return;
    }

    let res =  await applyProAndInviteCode({
      username: name, userIdentify: userRole, phone, wechat, orgName, position, email, cardId, inviteCode
    });

    if(res.code === 0) {
      await this.setState({submitting: false, submit: true, applyCount: 1})
    }
  }

  render(){
    const {name, userRole, phone, wechat, orgName, position, email, cardId,
      submit, submitting, showVerify, inviteCode }= this.state;
    let inputs = inputData;
    let values: string[]= [name, phone, wechat, email, userRole, orgName, position, inviteCode, cardId];
    inputs.map((v1,k1)=>{
      values.map((v2,k2)=>{
        if(k1==k2)
          return(v1.value = v2)
      })
    })

    if(submit){
      return(
        <div className={styles.form}>
          <div className={styles.submitted}>
            <div className={styles.row1}>恭喜您提交成功，我们将在1个工作日内完成审核</div>
            <div className={styles.row2}>
              <img src="./static-official/images/xiniu-service-2.png" width={130}/>
            </div>
            <div className={styles.row3}>联系烯牛客服完成审核</div>
            <div className={styles.close}>
              {this.props.onClose?
                  <Button withArrow width="248px" onClick={this.onClose}>关闭</Button>
                :
                  null
              }
            </div>
          </div>
        </div>
      )
    }

    return(
      <div className={styles.form}>
        {inputs.map((v, k) => {
          return(
            <InputItem key={k} {...v} showVerify={showVerify} onChange={this.onChange} uploadCard={this.uploadCard} />
          )
        })}
        <br />
        <Button withArrow width="248px" className={styles.confirm_btn} onClick={this.confirm}>立即申请</Button>
      </div>
    )
  }
}

export default Apply;
